var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({ref:"control",staticClass:"ui-select",class:{ 'is-block': _vm.block },attrs:{"value":_vm.value,"popper-class":_vm.resolvedPopperClass},on:{"input":function($event){return _vm.$emit('input', $event)},"visible-change":_vm.handleVisibleChange}},'el-select',_vm.$attrs,false),_vm.forwardedListeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }